import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, attachAnalyticsListeners } from "@/lib/analytics";

export const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    attachAnalyticsListeners();
  }, []);
  useEffect(() => {
    void trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

export default AnalyticsTracker;

